import { useState } from "react"

import { useDebouncedCallback } from "use-debounce"

import { Combobox } from "src/ui/Combobox/Combobox"
import { Maybe } from "src/utils/tsUtil"

export interface MultiPillSelectResult {
  name: string
  id: string
}

export function MultiPillSelect({
  value,
  onSelected,
  onCreate,
  options,
  onSearch,
  debounceTime = 500,
}: {
  value: MultiPillSelectResult[]
  onSelected: (selected: MultiPillSelectResult[]) => void
  onCreate?: (input: string) => void
  options: Maybe<MultiPillSelectResult[]>
  onSearch: (input: string) => void
  debounceTime?: number
}) {
  const [searchValue, setSearchValue] = useState("")

  const debouncedSearch = useDebouncedCallback(
    (search: string) => onSearch(search),
    debounceTime,
    { leading: true }
  )

  const shouldCreate = !!onCreate

  return (
    <Combobox
      multiple
      input={searchValue}
      selectedValue={value.map((v) => ({
        label: v.name,
        value: v.id,
      }))}
      options={[
        ...(!!options
          ? options.map((o) => ({
              label: o.name,
              value: o.id,
            }))
          : []),
        ...(shouldCreate && searchValue
          ? [
              {
                label: `Add "${searchValue}"`,
                value: `##new__${searchValue}`,
              },
            ]
          : []),
      ]}
      onInput={(input) => {
        debouncedSearch(input)
        setSearchValue(input)
      }}
      onChange={(value) => {
        const selectedAddNew = value.find((v) => v.value.startsWith("##new__"))

        if (shouldCreate && selectedAddNew) {
          onCreate(searchValue)
        } else {
          onSelected(
            value.map((v) => ({
              name: v.label,
              id: v.value,
            }))
          )
        }
        setSearchValue("")
      }}
    />
  )
}
